module.exports = __webpack_public_path__ + "img/img-auth-sideimg4.d598e89a.png";